try {
    window.$ = window.jQuery = require("jquery");

    require('slick-carousel');
    require('aos');
    window.AOS = require('aos');
    window.GLightbox = require('glightbox');
} catch (e) { }

function linesightDomReady(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        // Cookiebot may delay script execution until after DOMContentLoaded
        fn();
    }
}

linesightDomReady(function () {


    /**
     * initialise animations
     */
    try {
        if (window.AOS) {
            AOS.init();
            // Mark ready only after init so CSS fallback keeps content visible if AOS never runs
            document.documentElement.classList.add('aos-ready');
        }
    } catch (e) { }

    /**
     * navigation
     */
    $('.linesight-nav-bottomlinks-mobilenav').on('click', function () {
        if ($(this).attr('aria-expanded') == 'true') {
            $('body').css('overflow-y', 'hidden');
        } else {
            $('body').css('overflow-y', 'auto');
        }
    });
    // Handle clicks outside navigation to close collapses
    document.addEventListener('click', function (event) {
        const nav = document.querySelector('.linesight-nav');
        if (!nav) {
            return;
        }
        const openCollapses = document.querySelectorAll('.linesight-nav-wrapper .collapse.show');
        if (!nav.contains(event.target) && openCollapses.length > 0) {
            openCollapses.forEach(collapse => {
                const instance = window.bootstrap && bootstrap.Collapse
                    ? bootstrap.Collapse.getInstance(collapse)
                    : null;
                if (instance) {
                    instance.hide();
                }
            });
        }
    });
    if($('.linesight-nav-breadcrumbs').length) {
        $(window).on('scroll', function() {
            const scrollPercentage = ($(window).scrollTop() / $(window).height()) * 100;
            
            if (scrollPercentage >= 5) {
                $('.linesight-nav-breadcrumbs').addClass('scrolled');
            } else {
                $('.linesight-nav-breadcrumbs').removeClass('scrolled');
            }
        });
    }
    $('.nav-anchor-links-toggle').on('click', function () {
        if ($(this).attr('aria-expanded') == 'true') {
            $('.linesight-nav-breadcrumbs').addClass('breadcrumbs-collapsed');
            $('.linesight-nav-breadcrumbs-wrapper').addClass('linesight-nav-breadcrumbs-wrapper-dark');
        } else {
            $('.linesight-nav-breadcrumbs').removeClass('breadcrumbs-collapsed');
            $('.linesight-nav-breadcrumbs-wrapper').removeClass('linesight-nav-breadcrumbs-wrapper-dark');
        }
    });

    $('.ffwd_people-carousel').slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 4,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4000,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
        ],
    });


    /**
     * carousels
     */
    $('.ffwd_image-grid-carousel').slick({
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 3,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '160px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0px',
            }
        }
        ],
    });

    const contentLinksCarouselSettings = {
        infinite: false,
        arrows: true,
        dots: true,
        slidesToShow: 4.01,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3.01,
                }
            },
            {
                breakpoint: 1150,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3.1,
                }
            },
            {
                breakpoint: 899,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2.1,
                }
            },
            {
                breakpoint: 499,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1.1,
                }
            }
        ],
    };
    $('.ffwd_content-links-carousel').slick(contentLinksCarouselSettings);
    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            $('.ffwd_content-links-carousel').slick('unslick');
            $('.ffwd_content-links-carousel').slick(contentLinksCarouselSettings);
        }, 250);
    });

    $('.ffwd_testimonial-carousel').slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        dots: true,
        centerMode: true,
        mobileFirst: true,
        centerPadding: '0',
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '160px',
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '70px',
            }
        },
        {
            breakpoint: 340,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: '34px',
            }
        }
        ],
    });

    const $carousel = $('.ffwd_people-carousel').slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 4,
        arrows: false,
        dots: false,
        autoplay: false, 
        speed: 0,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [{
            breakpoint: 1100,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
        ],
    });
    const $track = $('.ffwd_people-carousel .slick-track');
    $track.append($track.children().clone());
    setTimeout(() => {
        $track.addClass('animate-track');
    }, 100);
    if (window.matchMedia('(max-width: 768px)').matches) {
        $('.ffwd_people-carousel').off('click');
        
        const pauseSvg = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#2B2D2B"><path d="M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z"/></svg>';
        const playSvg = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#2B2D2B"><path d="M320-200v-560l440 280-440 280Z"/></svg>';
        
        $('.ffwd_people-carousel').append(`<button class="carousel-toggle-btn">${pauseSvg}</button>`);
        
        $('.carousel-toggle-btn').on('click', function(e) {
            e.stopPropagation();
            toggleAnimation();
        });

        $('.ffwd_people-carousel .slick-slide').on('click', function(e) {
            if (!$(e.target).closest('.btn-read-bio').length) {
                toggleAnimation();
            }
        });

        function toggleAnimation() {
            $track.toggleClass('pause-animation');
            const $button = $('.carousel-toggle-btn');
            if ($track.hasClass('pause-animation')) {
                $button.html(playSvg);
            } else {
                $button.html(pauseSvg);
            }
        }
    }
    $('.ffwd_people-carousel .btn-read-bio').each(function() {
        const modalId = $(this).data('bs-target');
        $(modalId).on({
            'hidden.bs.modal': function() {
                if (window.matchMedia('(min-width: 769px)').matches) {
                    $('body').css('overflow-y', 'auto');
                    $track.removeClass('pause-animation');
                }
            },
            'show.bs.modal': function() {
                if (window.matchMedia('(min-width: 769px)').matches) {
                    $track.addClass('pause-animation');
                }
            }
        });
    });
    $('<style>')
        .text(`
            .ffwd_people-carousel .slick-track {
                display: flex !important;
                flex-wrap: nowrap !important;
            }
            .ffwd_people-carousel .slick-track.animate-track {
                animation: slideLeft 80s linear infinite;
            }
            @media (max-width: 768px) {
                .ffwd_people-carousel .slick-track.animate-track {
                    animation: slideLeft 40s linear infinite;
                }
            }
            .ffwd_people-carousel .slick-slide {
                flex: 0 0 auto;
            }
            @media (min-width: 769px) {
                .ffwd_people-carousel:hover .slick-track.animate-track {
                    animation-play-state: paused;
                }
            }
            .ffwd_people-carousel .slick-track.animate-track.pause-animation {
                animation-play-state: paused;
            }
            @keyframes slideLeft {
                from { transform: translateX(0); }
                to { transform: translateX(-50%); }
            }

            .carousel-toggle-btn {
                position: absolute;
                top: 15px;
                right: 15px;
                z-index: 10;
                background: rgba(255, 255, 255, 0.9);
                border: none;
                border-radius: 4px;
                padding: 8px;
                display: none;
                align-items: center;
                justify-content: center;
                box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                cursor: pointer;
            }

            .carousel-toggle-btn svg {
                display: block;
            }

            @media (max-width: 768px) {
                .carousel-toggle-btn {
                    display: flex;
                }
            }
        `)
        .appendTo('head');


    /**
     * counter
     */
    if ($('.ffwd_statistics-counter').length) {
        function getCounterDisplay($element) {
            var $display = $element.find('.ffwd_statistics-counter-value');

            return $display.length ? $display : $element;
        }

        function getCounterDecimals($element) {
            var fromAttr = parseInt($element.attr('data-decimals'), 10);
            if (!isNaN(fromAttr)) {
                return fromAttr;
            }

            var raw = String($element.data('value') ?? '').replace(/,/g, '').trim();
            var parts = raw.split('.');

            return parts.length > 1 ? parts[1].length : 0;
        }

        function formatCounterNumber(num, decimals) {
            decimals = decimals || 0;
            var fixed = decimals > 0 ? Number(num).toFixed(decimals) : String(Math.floor(num));
            var parts = fixed.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            return parts.join('.');
        }

        function startCounter(element) {
            var $element = $(element);
            var $display = getCounterDisplay($element);
            var rawValue = String($element.data('value') ?? '').replace(/,/g, '').trim();
            var countTo = parseFloat(rawValue, 10);
            var decimals = getCounterDecimals($element);

            if (isNaN(countTo) || $element.data('counting')) {
                return;
            }

            $element.data('counting', true);
            $display.text(formatCounterNumber(0, decimals));

            $({ countNum: 0 }).animate({ countNum: countTo }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                    $display.text(formatCounterNumber(this.countNum, decimals));
                },
                complete: function () {
                    $display.text(formatCounterNumber(countTo, decimals));
                }
            });
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startCounter(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        });

        $('.ffwd_statistics-counter').each(function () {
            // Reset visible value for users; .visually-hidden keeps the final figure for crawlers
            var decimals = getCounterDecimals($(this));
            getCounterDisplay($(this)).text(formatCounterNumber(0, decimals));
            observer.observe(this);
        });
    }

    /**
     * vertical card links
     */
    if ($('.ffwd_vertical-card').length > 0) {
        $('.ffwd_vertical-card').each(function () {
            var link = $(this).find('.ffwd_vertical-card-title').attr('href');
            $(this).attr('data-link', link);
        });

        let isSwiping = false;
        let isDragging = false;
        let clickTimeout;

        $('.ffwd_vertical-card').on('touchstart', function () {
            isSwiping = false;
            clearTimeout(clickTimeout);
        });

        $('.ffwd_vertical-card').on('touchmove', function () {
            isSwiping = true;
        });

        $('.ffwd_vertical-card').on('mousedown', function () {
            isDragging = false;
            clearTimeout(clickTimeout);
        });

        $('.ffwd_vertical-card').on('mousemove', function () {
            isDragging = true;
        });

        $('.ffwd_vertical-card').on('mouseup', function (e) {
            var link = $(this).data('link');
            if (link && !$(e.target).closest('a, .ffwd-lightbox-trigger').length) {
                if (!isSwiping && !isDragging) {
                    clickTimeout = setTimeout(function () {
                        window.location.href = link;
                    }, 300);
                }
            }
        });

        $('.ffwd_vertical-card').on('mouseleave', function () {
            isDragging = false;
        });
    }

    /**
     * generic lightbox
     */
    const lightboxSelectors = document.querySelectorAll('.ffwd-lightbox-trigger');
    if (lightboxSelectors.length && typeof GLightbox !== 'undefined') {
        const lightboxTriggerList = Array.from(lightboxSelectors);
        const lightbox = GLightbox({
            selector: '.ffwd-lightbox-trigger',
            openEffect: 'zoom',
            closeEffect: 'zoom',
            closeOnOutsideClick: false,
            width: '70vw',
            // draggable: false,
        });
        
        // Function to adjust lightbox width based on screen size
        const adjustLightboxWidth = () => {
            const lightboxContent = document.querySelector('.gslide.current .ffwd_lightbox-content');
            if (lightboxContent) {
                const slideInline = lightboxContent.closest('.gslide-inline');
                const ginlinedContent = lightboxContent.closest('.ginlined-content');

                const setElementWidth = (element, widthValue) => {
                    if (!element) {
                        return;
                    }
                    element.style.width = widthValue;
                    element.style.maxWidth = widthValue;
                };

                if (slideInline) {
                    if (window.innerWidth <= 768) {
                        setElementWidth(slideInline, '100%');
                        setElementWidth(ginlinedContent, '100%');
                    } else if(window.innerWidth <= 1024) {
                        setElementWidth(slideInline, '80vw');
                        setElementWidth(ginlinedContent, '80vw');
                    } else {
                        setElementWidth(slideInline, '70vw');
                        setElementWidth(ginlinedContent, '70vw');
                    }
                    slideInline.scrollTop = 0;
                }
            }
        };
        
        // Add class to body when lightbox opens
        lightbox.on('open', () => {
            const currentSlide = document.querySelector('.gslide.current .ffwd_lightbox-content');
            if (currentSlide) {
                document.body.classList.add('ffwd-lightbox-open');
                // Adjust width on open
                setTimeout(adjustLightboxWidth, 100);
                
                // Append close button to GLightbox container
                setTimeout(() => {
                    const glightboxContainer = document.querySelector('.glightbox-container .gcontainer');
                    const existingCloseBtn = glightboxContainer?.querySelector('.ffwd_lightbox-close--bottom-left');
                    
                    if (glightboxContainer && !existingCloseBtn) {
                        const closeButton = document.createElement('a');
                        // closeButton.type = 'button';
                        closeButton.className = 'ffwd_lightbox-close ffwd_lightbox-close--bottom-left';
                        closeButton.setAttribute('data-glightbox-close', '');
                        closeButton.setAttribute('aria-label', 'Close lightbox');
                        closeButton.innerHTML = '<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="35" height="35" rx="17.5" fill="white"/><path d="M24.5 17.5H10.5" stroke="#ED0080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5 24.5L10.5 17.5L17.5 10.5" stroke="#ED0080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                        
                        // Add click handler to close the lightbox
                        closeButton.addEventListener('click', (e) => {
                            e.preventDefault();
                            lightbox.close();
                        });
                        
                        glightboxContainer.appendChild(closeButton);
                    }
                }, 150);
            }
        });
        
        // Remove class when lightbox closes
        lightbox.on('close', () => {
            document.body.classList.remove('ffwd-lightbox-open');
            
            // Remove the custom close button
            const glightboxContainer = document.querySelector('.glightbox-container');
            const customCloseBtn = glightboxContainer?.querySelector('.ffwd_lightbox-close--bottom-left');
            if (customCloseBtn) {
                customCloseBtn.remove();
            }
        });
        
        // Adjust width on window resize
        window.addEventListener('resize', () => {
            if (document.body.classList.contains('ffwd-lightbox-open')) {
                adjustLightboxWidth();
            }
        });

        const openLightboxForTrigger = (trigger) => {
            if (!trigger) {
                return;
            }

            const targetIndex = lightboxTriggerList.indexOf(trigger);
            if (targetIndex > -1) {
                lightbox.openAt(targetIndex);
            } else {
                trigger.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
        };

        const triggerLightboxFromCard = (card) => {
            const trigger = card.querySelector('.ffwd-lightbox-trigger');
            if (!trigger) {
                return;
            }
            openLightboxForTrigger(trigger);
        };

        const handleCardClick = function(event) {
            if (event.target.closest('.ffwd-lightbox-trigger')) {
                return;
            }

            event.preventDefault();
            triggerLightboxFromCard(this);
        };

        const handleCardKeydown = function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                triggerLightboxFromCard(this);
            }
        };

        document.querySelectorAll('.ffwd_vertical-card--lightbox').forEach((card) => {
            // Ensure card is focusable for keyboard users
            if (!card.hasAttribute('tabindex')) {
                card.setAttribute('tabindex', '0');
            }
            card.addEventListener('click', handleCardClick);
            card.addEventListener('keydown', handleCardKeydown);
        });

        // Handle deeplink clicks from WYSIWYG content
        const handleDeeplinkClick = (event) => {
            const link = event.target.closest('a');
            if (!link || !link.href) {
                return;
            }

            let hash = '';
            
            // Check if it's a hash link (deeplink)
            try {
                const url = new URL(link.href, window.location.href);
                hash = url.hash;
            } catch (e) {
                // If URL parsing fails, check if it's a relative hash link
                if (link.href.startsWith('#')) {
                    hash = link.href;
                } else if (link.getAttribute('href') && link.getAttribute('href').startsWith('#')) {
                    hash = link.getAttribute('href');
                }
            }
            
            if (!hash || hash === '#') {
                return; // Not a hash link, allow normal navigation
            }

            // Normalize hash (ensure it starts with #)
            if (!hash.startsWith('#')) {
                hash = '#' + hash;
            }

            // Find lightbox with matching deeplink
            // The deeplink is stored in data-lightbox-deeplink attribute
            const lightboxContent = document.querySelector(`[data-lightbox-deeplink="${hash}"]`);
            
            if (lightboxContent) {
                event.preventDefault();
                event.stopPropagation();
                
                // Find the corresponding trigger
                const lightboxId = lightboxContent.id;
                const trigger = document.querySelector(`.ffwd-lightbox-trigger[href="#${lightboxId}"]`);
                
                if (trigger) {
                    openLightboxForTrigger(trigger);
                }
            }
            // If no matching lightbox found, allow normal navigation
        };

        // Add click handler to all anchor tags in WYSIWYG content
        // Use event delegation to handle dynamically added content
        document.addEventListener('click', (event) => {
            // Check if click is within WYSIWYG content
            const wysiwygContent = event.target.closest('.ffwd_wysiwyg, .ffwd_lightbox-paragraph');
            if (wysiwygContent) {
                const link = event.target.closest('a');
                if (link && link.href) {
                    handleDeeplinkClick(event);
                }
            }
        }, true); // Use capture phase to catch before other handlers

        // Handle deeplink on page load (if URL contains a hash matching a lightbox deeplink)
        const handleInitialDeeplink = () => {
            const hash = window.location.hash;
            if (!hash || hash === '#') {
                return;
            }

            // Find lightbox with matching deeplink
            const lightboxContent = document.querySelector(`[data-lightbox-deeplink="${hash}"]`);
            
            if (lightboxContent) {
                // Small delay to ensure GLightbox is fully initialized
                setTimeout(() => {
                    const lightboxId = lightboxContent.id;
                    const trigger = document.querySelector(`.ffwd-lightbox-trigger[href="#${lightboxId}"]`);
                    
                    if (trigger) {
                        openLightboxForTrigger(trigger);
                    }
                }, 100);
            }
        };

        // Check for deeplink on page load
        handleInitialDeeplink();

        // Also handle hash changes (e.g., browser back/forward)
        window.addEventListener('hashchange', handleInitialDeeplink);
    }

    /**
     * Vimeo modal: load iframe after open (Cookiebot-safe), clear on close
     */
    var videoModals = document.querySelectorAll('.ffwd_image-banner-video-modal');
    if (videoModals.length > 0) {
        videoModals.forEach(function (modal) {
            if (modal.dataset.vimeoBound === '1') {
                return;
            }
            modal.dataset.vimeoBound = '1';

            function resolveVimeoSrc() {
                var existing = modal.getAttribute('data-vimeo-src');
                if (existing) {
                    return existing;
                }
                var id = modal.getAttribute('data-vimeo-id');
                if (!id) {
                    return '';
                }
                var query = modal.getAttribute('data-vimeo-query')
                    || 'api=1&dnt=1&title=0&byline=0&portrait=0&app_id=122963';
                return 'https://player.vimeo.com/video/' + id + '?' + query;
            }

            modal.addEventListener('shown.bs.modal', function () {
                var vimeoSrc = resolveVimeoSrc();
                var vimeoFrame = modal.querySelector('iframe');
                if (vimeoSrc && vimeoFrame) {
                    vimeoFrame.setAttribute('data-cookieconsent', 'ignore');
                    if (vimeoFrame.getAttribute('src') !== vimeoSrc) {
                        vimeoFrame.setAttribute('src', vimeoSrc);
                    }
                }
            });

            modal.addEventListener('hidden.bs.modal', function () {
                var video = modal.querySelector('video');
                if (video) {
                    video.pause();
                }

                var vimeoFrame = modal.querySelector('iframe[src*="vimeo"]');
                if (vimeoFrame) {
                    if (window.Vimeo && window.Vimeo.Player) {
                        try {
                            var vimeoPlayer = new Vimeo.Player(vimeoFrame);
                            vimeoPlayer.pause();
                        } catch (e) {
                            // ignore
                        }
                    }
                    vimeoFrame.setAttribute('src', 'about:blank');
                }

                var youtubeFrame = modal.querySelector('iframe[src*="youtube"]');
                if (youtubeFrame) {
                    var youtubeMessage = JSON.stringify({ event: 'command', func: 'pauseVideo' });
                    youtubeFrame.contentWindow.postMessage(youtubeMessage, '*');
                }
            });
        });
    }

    /**
     * floating key contact
     */
    if ($('.ffwd_key-contact').length > 0) {
        let hasScrolled = false;

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 150) {
                if (!hasScrolled) {
                    $('.ffwd_key-contact').addClass('visible');
                    hasScrolled = true;
                }
            } else {
                if (hasScrolled) {
                    $('.ffwd_key-contact').removeClass('visible');
                    hasScrolled = false;
                }
            }
        });
    }

    /**
     * start text animation for ffwd_statistics-letters
     */
    function startTextAnimation(element) {
        var $element = $(element);
        var textTo = $element.data('text');
        var currentText = $element.text();

        if (currentText === textTo) {
            return;
        }

        // Text scramble effect
        const scrambleText = (text) => {
            const upperCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const lowerCharacters = 'abcdefghijklmnopqrstuvwxyz';
            const baseInterval = text.length > 10 ? 20 : 30;
            const shuffleCount = 10;
            let currentIndex = 0;

            const scrambleNextLetter = () => {
                if (currentIndex < text.length) {
                    let scrambledText = text.split('');
                    
                    // Skip spaces, dashes, and commas
                    if (text[currentIndex] === ' ' || text[currentIndex] === '-' || text[currentIndex] === ',') {
                        scrambledText[currentIndex] = text[currentIndex];
                        $element.text(scrambledText.join(''));
                        currentIndex++;
                        scrambleNextLetter();
                        return;
                    }

                    let shuffleIterations = 0;

                    const shuffleInterval = setInterval(() => {
                        // Choose character pool based on target letter case
                        const characterPool = text[currentIndex] === text[currentIndex].toUpperCase() 
                            ? upperCharacters 
                            : lowerCharacters;
                        const randomChar = characterPool[Math.floor(Math.random() * characterPool.length)];
                        scrambledText[currentIndex] = randomChar;
                        $element.text(scrambledText.join(''));

                        shuffleIterations++;
                        if (shuffleIterations >= shuffleCount) {
                            clearInterval(shuffleInterval);
                            scrambledText[currentIndex] = text[currentIndex];
                            $element.text(scrambledText.join(''));
                            currentIndex++;
                            scrambleNextLetter();
                        }
                    }, baseInterval);
                }
            };

            scrambleNextLetter();
        };

        scrambleText(textTo);
    }

    if ($('.ffwd_statistics-letters').length) {
        const textObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startTextAnimation(entry.target);
                    textObserver.unobserve(entry.target);
                }
            });
        });

        $('.ffwd_statistics-letters').each(function () {
            textObserver.observe(this);
        });
    }

    /**
     * card block offset height calculation
     */
    function calculateCardBlockOffsetHeights() {
        $('.ffwd_card-block-offset').each(function () {
            var $container = $(this);
            var $offsetContainer = $container.find('.ffwd_card-block-offset-container');
            
            if ($offsetContainer.length > 0) {
                var $childDivs = $offsetContainer.children('div');
                if ($(window).width() >= 1100) {
                    if ($childDivs.length > 1) {
                        var maxHeight = 0;
                        
                        $childDivs.each(function() {
                            var $child = $(this);
                            var childHeight = $child.outerHeight();
                            if (childHeight > maxHeight) {
                                maxHeight = childHeight;
                            }
                        });
                        
                        if (maxHeight > 0) {
                            $offsetContainer.css('height', maxHeight + 'px');
                        }
                    }
                } else {
                    $offsetContainer.css('height', 'auto');
                }
            }
        });
    }
    calculateCardBlockOffsetHeights();
    let cardBlockResizeTimer;
    $(window).on('resize', function () {
        clearTimeout(cardBlockResizeTimer);
        cardBlockResizeTimer = setTimeout(function () {
            $('body').height();
            calculateCardBlockOffsetHeights();
        }, 100);
    });

});